import { getOptionsForFeature, OwsOptionsFeatureType } from 'owa-outlook-service-option-store';
import type { PinnablePane, PinnedPaneOptions } from 'owa-outlook-service-option-store';

export function getPinnedPaneSetting(): PinnablePane {
    return getOptionsForFeature<PinnedPaneOptions>(OwsOptionsFeatureType.PinnedPane).pinnedPane;
}
